var breadcrumbContent = document.querySelector('.breadcrumb__content');

window.addEventListener("resize", checkBreadcrumb);

// ---------- CHECK IF ".breadcrumb__content" IS PRESENT AND EXECUTE "compareContainerContent()" IF TRUE
function checkBreadcrumb(){
if (breadcrumbContent) {
  compareContainerContent();
}
}
checkBreadcrumb();

//---------- Reset Breadcrumb
function resetBreadcrumb(){
  if (breadcrumbContent){
   var resetScrollPosition = breadcrumbContent.scrollWidth - breadcrumbContent.offsetWidth;
   breadcrumbContent.scrollLeft = resetScrollPosition;
  }
}

// ---------- IS CONTENT LARGER THAN CONTAINER
function compareContainerContent() {
  var breadcrumbContentWidth = breadcrumbContent.offsetWidth,
    children = breadcrumbContent.children,
    totalWidth = 0;

  for (var i = 0; i < children.length; i++) {
    totalWidth += children[i].offsetWidth;
  }

  // ---------- HIDE/SHOW SHADING IF CONTENT IS WIDER THAN THE CONTAINER
  if (totalWidth >= breadcrumbContentWidth) {
    addScrollShader();
  }
}

// ---------- APPLY SCROLL SHADING
function addScrollShader() {
  var divShader = document.createElement("div"),
    parentDiv = breadcrumbContent.parentNode,
    breadcrumbShade = document.querySelector(".on-page-nav__hidden-menu");

  //Scroll reset
  resetBreadcrumb();

  divShader.className += "on-page-nav__hidden-menu on-page-nav__hidden-menu--left";

  if (!breadcrumbShade){
  parentDiv.insertBefore(divShader, breadcrumbContent);
  }
  shadeLeftShadeRight();
}

// ---------- TOGGLE SHADING LEFT / RIGHT
function shadeLeftShadeRight() {
  breadcrumbContent.onscroll = function () {

    var scroll__start = breadcrumbContent.scrollLeft,
      scroll__width = breadcrumbContent.scrollWidth,
      on_page_nav__hm = document.querySelector('.on-page-nav__hidden-menu'),
      visWdth_pixelScrl = parseInt(breadcrumbContent.offsetWidth + breadcrumbContent.scrollLeft);
      // console.log(scroll__start+"Scroll Start");
      // console.log(visWdth_pixelScrl + "visWdth_pixelScrl");
      // console.log(scroll__width + "scroll__width");

    if (scroll__start == 0) {
      on_page_nav__hm.classList.remove("on-page-nav__hidden-menu--left");
      on_page_nav__hm.classList.add("on-page-nav__hidden-menu--right");
      //console.log("Right Blur");
    }
    else if (visWdth_pixelScrl == scroll__width) {
      on_page_nav__hm.classList.remove("on-page-nav__hidden-menu--right");
      on_page_nav__hm.classList.add("on-page-nav__hidden-menu--left");
      //console.log("Left Blur");
    }

    // ---------- VISIBLE WIDTH + PIXEL SCROLLED = TOTAL WIDTH
    // if (visWdth_pixelScrl == scroll__width) {
    //   on_page_nav__hm.classList.remove("on-page-nav__hidden-menu--right");
    //   on_page_nav__hm.classList.add("on-page-nav__hidden-menu--left");
    // }
  }
}

  //Scroll reset on Timeout
  setTimeout(function () {
    resetBreadcrumb();
  }, 2000)
